import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllFilters: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.footer.view-all-filters',
		defaultMessage: 'View all filters',
		description: 'Message for the view all filters menu item in the filters submenu',
	},
});
